(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bundles"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var card = event.target.closest('[data-variant-card]');
    if (!card || !window.KORENA) return;
    var selection = {
      id: card.dataset.variantCard,
      title: card.dataset.variantTitle,
      prices: {
        price: card.dataset.variantPrice,
        compare: card.dataset.variantCompare,
        saving: card.dataset.variantSaving,
        savingShip: card.dataset.variantSavingShip,
      },
    };
    window.KORENA.selectVariant(selection.id, selection.title, selection.prices);
    try {
      sessionStorage.setItem('korena:variant', JSON.stringify(selection));
    } catch (error) {}
  });

  (function () {
    try {
      var stored = JSON.parse(sessionStorage.getItem('korena:variant') || 'null');
      if (!stored || !window.KORENA) return;
      // Tolerate a selection stored by an earlier version of the theme.
      window.KORENA.selectVariant(stored.id, stored.title, stored.prices || { price: stored.price });
    } catch (error) {}
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["faq"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var trigger = event.target.closest('.faql .fqq');
    if (!trigger) return;
    var item = trigger.parentElement;
    var list = trigger.closest('.faql');
    var wasOpen = item.classList.contains('open');
    list.querySelectorAll('.fq').forEach(function (other) {
      other.classList.remove('open');
      other.querySelector('.fqq').setAttribute('aria-expanded', 'false');
    });
    if (!wasOpen) {
      item.classList.add('open');
      trigger.setAttribute('aria-expanded', 'true');
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.gth .gt');
    if (!thumb) return;
    var scope = thumb.closest('.hg') || document;
    var index = thumb.dataset.i;
    scope.querySelectorAll('.gal .ph').forEach(function (slide) {
      slide.classList.toggle('on', slide.dataset.i === index);
    });
    scope.querySelectorAll('.gth .gt').forEach(function (button) {
      button.classList.toggle('on', button === thumb);
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["reviews"] && !Shopify.designMode) return;
  try {
    
  // Judge.me's average-rating line prints the number but, in most of its
  // header styles, no stars. The landing design has them, so draw the theme's
  // own star row from the number the widget printed — the two can't disagree.
  (function () {
    var host = document.querySelector('.appblk--full');
    if (!host) return;

    function drawStars() {
      host.querySelectorAll('.jm-average-rating-display').forEach(function (display) {
        if (display.querySelector('.jm-star-rating, .korena-app-stars')) return;
        var number = display.querySelector('p.jm-text');
        if (!number) return;
        var value = parseFloat(number.textContent.replace(',', '.'));
        if (isNaN(value)) return;
        var filled = Math.max(0, Math.min(5, Math.round(value)));
        var stars = document.createElement('span');
        stars.className = 'korena-app-stars';
        stars.setAttribute('aria-hidden', 'true');
        stars.textContent = '★★★★★'.slice(0, filled) + '☆☆☆☆☆'.slice(0, 5 - filled);
        number.parentElement.insertBefore(stars, number);
      });
    }

    new MutationObserver(drawStars).observe(host, { childList: true, subtree: true });
    drawStars();
  })();

  } catch(e) { console.error(e); }
})();
})();
